import { AbstractControl, ValidationErrors } from '@angular/forms'
import { ErrorMessage } from '@northfork/ng-basics'
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays'

export const DateDiffValidator = (otherDate: string, maxDays: number) => {
  return (control: AbstractControl): ValidationErrors | null => {
    const otherDateControl = control.parent?.get(otherDate)

    if (!otherDateControl?.value || !control.value) {
      return null
    }
    const diff = differenceInCalendarDays(
      new Date(control.value),
      new Date(otherDateControl.value),
    )
    if (Math.abs(diff) > maxDays) {
      return {
        DateDiffError: {
          maxDays,
        },
      }
    }

    return null
  }
}

export const dateDiffValidationMessages: ErrorMessage[] = [
  {
    error: 'DateDiffError',
    format: (label, error): string => {
      return `Date difference must be less than ${error.maxDays} days.`
    },
  },
]
